<app-select-remote #dropDown (parentFun)="onChange($event)" [(model)]="selectedData" (click)="onClick();$event.stopPropagation()" [fetchUrl]="fetchUrl"></app-select-remote>
